import loadable from '@loadable/component';
import ChannelComponentWrapper from './ChannelComponentWrapper';
import { CHANNEL } from 'domains/landing-autos/enums/channel';

const BCPConfirmationComponent = loadable(
  () => import('../domains/auto-efectivo/thanks/containers/app-e2e'),
);
const YapeConfirmationComponent = loadable(
  () =>
    import('../domains/auto-efectivo/remarketing/thanks/containers/app-yape'),
);
const DefaultConfirmationComponent = loadable(
  () =>
    import(
      '../domains/quotation/containers/payment-confirmed/payment-confirmed'
    ),
);

const channelComponentMap = {
  [CHANNEL.BCP_AUTOEFECTIVO]: BCPConfirmationComponent,
  [CHANNEL.YAPE_AUTOEFECTIVO]: YapeConfirmationComponent,
};

const ConfirmationPageWrapper = () => (
  <ChannelComponentWrapper
    channelComponentMap={channelComponentMap}
    defaultComponent={DefaultConfirmationComponent}
  />
);

export default ConfirmationPageWrapper;
